import axios from "axios";
import { store } from "../../index";
import { BASE_URL } from "../../constants/constants";
import { LOGOUT_SUCCESS } from "../../constants/constants";
import { toast } from "react-toastify";
import { initialState } from "../../store/reducers/authReducers";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials:true,
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("persist:root");
      store.dispatch({ type: LOGOUT_SUCCESS });
      toast.info(
        "Odjavljeni ste iz aplikacije. Za nastavak rada odaberite prijavu!",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
        }
      );
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
